// ============================
// App.jsx

// ============================
// pages/Login.jsx
// ============================
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();

    if (username === "theguide" && password === "0754") {
      localStorage.setItem("auth", "true");
      setError("");
      navigate("/dashboard");
    } else {
      setError("Invalid username or password");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#06242e]">
      <div className="bg-white w-full max-w-md rounded-xl shadow-2xl p-10">
        <h1 className="text-4xl font-bold mb-8 text-gray-900">Log in</h1>

        <form onSubmit={handleLogin} className="space-y-6">
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full px-4 py-3 border rounded-md"
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-3 border rounded-md"
          />

          {error && <p className="text-red-500 text-sm">{error}</p>}

          <button
            type="submit"
            className="w-full bg-cyan-500 hover:bg-cyan-600 text-white py-3 rounded-md"
          >
            Log in
          </button>
        </form>
      </div>
    </div>
  );
}


// ============================
// pages/Dashboard.jsx


